import {gql} from '@apollo/client';

export const GET_STOCK_PRICE_ALERT_HISTORY = gql`
  query GetStockPriceAlertHistory(
    $page: Int
    $limit: Int
    $companyId: ID
    $priceFromDate: DateTime
    $priceEndDate: DateTime
    $direction: StockPriceAlertDirection
    $priceMovementRange: StockPriceMovementRangeFilter
  ) {
    getStockPriceAlertHistory(
      page: $page
      limit: $limit
      companyId: $companyId
      priceFromDate: $priceFromDate
      priceEndDate: $priceEndDate
      direction: $direction
      priceMovementRange: $priceMovementRange
    ) {
      ... on ResponseWithStockPriceAlertHistory {
        data {
          id
          companyId
          company {
            id
            name
          }
          symbol
          percentageChange
          direction
          openingPrice
          previousLastPrice
          lastPrice
          priceDate
          createdAt
          updatedAt
        }
        pagination {
          total
          page
          limit
          next
          hasPrevPage
          hasNextPage
          pages
          previous
        }
      }
      ... on Error {
        message
        statusCode
        type
        errorTypeEnum
        retryAfter
      }
    }
  }
`;
